<template>
<!-- 整图样式 -->
  <div
    id="coverPic"
    class="coverPic"
    v-bind:style="{backgroundImage:'url(' +'\''+ tbInfo.image1 +'\''+ ')', backgroundRepeat:'no-repeat'}"
    v-loading="loading"
  >
    <div @click="goLink" class="link" v-if="tbInfo.link"></div>
    <div  class="title" v-if="tbInfo.name">{{tbInfo.title}}</div>
  </div>
</template>

<script>
export default {
  name: "coverPic",
  data() {
    return {
      loading: false
    };
  },
  props: ["tbInfo"],
  methods: {
    // 跳转链接
    goLink(){
       window.open(this.tbInfo.link)
    }
  },
  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
.coverPic {
  width: 100%;
  height: 100%;
  /* background: url("../../../static/images/banner02.jpg") no-repeat; */
  background-position: center;
  background-size: cover;
  position: relative;
}
.link{
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.title{
  position: absolute;
  font-weight: 700;
  font-size: 35px;
  color: #fff;
  top: 260px;
  left: 105px;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/coverPic.vue